import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import Project from './Project';
import "./firebase/Firebasedata";
import { BrowserRouter, Route, Routes, Navigate} from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/project" element={<Project />}/>
        <Route path="/projects" element={<Home gotoProjects={true} />}/>
        <Route path="/projects/filter/:filterType" element={<Home gotoProjects={true} useFilter={true}/>}/>
        <Route path="*" element={<Navigate to="/projects" />} />
      </Routes>
    </BrowserRouter>
  </>
);
